"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var FadeIn = exports.FadeIn = function () {
  function FadeIn() {
    _classCallCheck(this, FadeIn);

    this.node = null;
  }

  _createClass(FadeIn, [{
    key: "bind",
    value: function bind(node) {
      this.node = node;
    }
  }, {
    key: "unbind",
    value: function unbind(node) {
      this.node = null;
    }
  }, {
    key: "update",
    value: function update() {
      var _this = this;

      var duration = arguments.length <= 0 || arguments[0] === undefined ? 300 : arguments[0];

      this.node.style.opacity = 0;
      this.node.style.transition = "opacity " + duration + "ms";
      window.requestAnimationFrame(function () {
        return _this.node.style.opacity = 1;
      });
    }
  }]);

  return FadeIn;
}();